<template>
    <div>
        <fe-filter-btn
            ref="filterBtn"
            v-model="filterValue"
            data-test="students3d-filter-by-gender-btn"
            :url="genderUrl"
            root-property="gender"
            item-value="value"
            item-text="display_name"
            :title="displayName"
            :item-processor="processGenderItems"
            multiple
            show-clear-button
            show-apply-button
            :close-on-select="false"
            @apply="emitFilter"
            @clear="clearFilter"
        />
    </div>
</template>

<script>
import * as Util from '../../Util'
import { processDisplayNameGroupItems } from './processDisplayNameGroupItems'

export default {
    name: 'GenderPanel',
    rank: 1,

    data() {
        return {
            oldFilter: null,
            displayName: 'Gender',
            type: 'gender',
            filterValue: { included: [], excluded: [] },
            _applying: false,
        }
    },

    computed: {
        genderUrl() {
            return this.$models.getUrl('gender', 'read')
        },
    },

    methods: {
        processGenderItems: processDisplayNameGroupItems,
        load(oldFilter) {
            this.oldFilter = oldFilter
            const genders = oldFilter.editorParams?.genders || []
            this.filterValue = {
                included: genders,
                excluded: [],
            }
        },
        clearFilter() {
            this.filterValue = { included: [], excluded: [] }
        },
        openDropdown() {
            this.$nextTick(() => {
                if (this.$refs.filterBtn) this.$refs.filterBtn.openMenu = true
            })
        },
        emitFilter() {
            if (this._applying) return
            const included = this.filterValue.included || []
            if (included.length === 0) {
                if (this.oldFilter) {
                    this.$emit('input', null, this.oldFilter)
                    this.oldFilter = null
                    if (this.$refs.filterBtn) this.$refs.filterBtn.openMenu = false
                }
                return
            }

            this._applying = true
            setTimeout(() => { this._applying = false }, 100)

            const uniqueId = Util.UUIDv4()
            const name = included.map(x => x.display_name).join(', ')
            const ids = []
            included.forEach(m => {
                if (!m.display_name_group) {
                    ids.push(m.value)
                } else {
                    ids.push(...m.display_name_group)
                }
            })

            const filter = {
                type: this.type,
                id: uniqueId,
                report: true,
                params: this.$_.pickBy({ gender: ids }, x => !this.$_.isBlank(x)),
            }
            Object.defineProperties(filter, {
                editor: { value: this },
                editorParams: { value: { genders: [...included] } },
                chipText: { value: name },
                tooltipData: { value: { Genders: name } },
            })
            this.$emit('input', filter, this.oldFilter)
            this.oldFilter = filter
            if (this.$refs.filterBtn) this.$refs.filterBtn.openMenu = false
        },
    },
}
</script>

<style lang="scss" scoped>
</style>
